@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

$dropdown-min-multiselect-width: 200px;
$val-search-field-width: 250px;
$max-workOrders-height: 40vh;
$var-report-type-list-small-text: 14px;
$var-report-type-list-min-height: 300px;

.modal-body {
	padding: Constants.$val-spacing-m;
}

.modal-body-row {
	margin-bottom: Constants.$val-spacing-s;
}

.scrollable-container {
	max-height: $max-workOrders-height;
	overflow-y: auto;
}

.bold-text {
	font-weight: bold;
}

.light-italic-text {
	background-color: Colors.$col-white;
	color: Colors.$col-grey;
	font-style: italic;
}

.multiselect-options {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	color: Colors.$col-design-blue500;
	font-size: Constants.$val-fontSizeSmall;
	min-width: $dropdown-min-multiselect-width;
	margin-top: 0 !important;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	border-bottom: 1px solid Colors.$col-greyMid;

	&__controls {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-s;

		& button {
			padding: 0 !important;
		}
	}
}


.search-input {
	position: relative;
	align-items: center;
	height: Constants.$val-inputHeight;
	width: $val-search-field-width !important;

	& > input {
		height: 100%;
		width: $val-search-field-width !important;
		min-width: Constants.$val-textFilterMinWidth;
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;

		&::placeholder {
			color: Colors.$col-greyFontLight;
		}

		&[placeholder*="by"] {
			min-width: 160px;
		}
	}

	& > [class^="icon-search"] {
		position: absolute;
		right: Constants.$val-spacing-s;
		font-size: Constants.$val-fontSizeBig;
		color: Colors.$col-greyFontLight;
		top: Constants.$val-spacing-s;
	}

}

.report-type-list {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	max-height: $var-report-type-list-min-height;
	overflow: auto;

	&--empty {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: Constants.$val-spacing-l;
		color: Colors.$col-greyFontLight;
		font-style: italic;
	}

	&--non-selected {
		padding: Constants.$val-spacing-l;
		display: flex;
		font-style: italic;
		justify-content: center;
		align-items: center;
		height: 100%;
	}
}

.report-type-row {
	display: grid;
	grid-template-columns: 210px 210px 210px 80px;

	&__small-text {
		font-size: $var-report-type-list-small-text;
	}
}
